
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import SimpleMap from '../../../core/components/Map/SimpleMap.vue';
import LabelWithValue from '../../../core/components/Indicators/LabelWithValue.vue';
import LoadingIndicator from '../../../core/components/Generics/LoadingIndicator.vue';
import Button from '../../../core/components/Generics/Button.vue';
import { Units } from '../../../shared/types/values/unitLabels';
import { SatellitalLayersInfo, ZonificationInfo } from '../../../shared/types/satellital/layers';

@Component({
  components: {
    SimpleMap,
    LabelWithValue,
    Button,
    LoadingIndicator
  },
})
export default class SummaryItems extends Vue {
  @Prop({default: ''}) modalTitle: string;
  @Prop({default: {
    date: null,
      png_url: null,
      bar_url: '',
      total_area: null,
      zones: [],
      bounds: null
  }}) info: ZonificationInfo;

  defaultValues: object = {
     date: null,
      png_url: null,
      bar_url: '',
      total_area: null,
      zones: [],
      bounds: null
  }

  summaryInfo: ZonificationInfo = {
    date: null,
    bar_url: '',
    png_url: null,
    total_area: null,
    zones: [],
    bounds: null
  }
  minWidthValueSummary: number = 80;
  minWidthValue: number = 120;

  get fixedLabelWidth() {
    // Use a fixed width that accommodates most labels with wrapping
    return 140;
  }

  mounted(){
    this.summaryInfo = this.info;
  }

  @Watch('info', {immediate: true, deep: true})
  onInfoChanged(newInfo){
    this.summaryInfo = newInfo;
  }

  
  labelsUnits = Units;
  loadingIndicators: boolean = true;


  updateLoadingIndicator(value: boolean){
    this.loadingIndicators = value;
  }

  updateLayersInfo(info: ZonificationInfo){
    if(info == null){
      info = this.defaultValues as ZonificationInfo
    }
    this.summaryInfo = info
  }
}
